export const PrintIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1001 11.5239C5.89953 11.5491 5.6995 11.5759 5.5 11.6044M6.1001 11.5239C7.54131 11.3431 9.00978 11.25 10.5 11.25C11.9902 11.25 13.4587 11.3431 14.8999 11.5239M6.1001 11.5239L5.78409 15M14.8999 11.5239C15.1005 11.5491 15.3005 11.5759 15.5 11.6044M14.8999 11.5239L15.2159 15M15.2159 15L15.4071 17.1026C15.457 17.6516 15.0247 18.125 14.4734 18.125H6.52659C5.97531 18.125 5.54303 17.6516 5.59294 17.1026L5.78409 15M15.2159 15H16.125C17.1605 15 18 14.1605 18 13.125V7.87974C18 6.97896 17.3601 6.20068 16.4692 6.06738C15.9411 5.98837 15.4096 5.91967 14.875 5.86151M5.78409 15H4.875C3.83947 15 3 14.1605 3 13.125V7.87974C3 6.97896 3.63992 6.20068 4.53078 6.06738C5.05889 5.98837 5.59036 5.91967 6.125 5.86151M14.875 5.86151C13.4381 5.70521 11.9784 5.625 10.5 5.625C9.02156 5.625 7.56186 5.70521 6.125 5.86151M14.875 5.86151V2.8125C14.875 2.29473 14.4553 1.875 13.9375 1.875H7.0625C6.54473 1.875 6.125 2.29473 6.125 2.8125V5.86151M15.5 8.75H15.5063V8.75625H15.5V8.75ZM13 8.75H13.0063V8.75625H13V8.75Z"
        stroke="#47AA62"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
